<div class="grid__cell grid__cell--widget grid__cell--full widget__bag"
     [dragula]='"widget-bag"'>
  <swb-footer-settings></swb-footer-settings>
</div>
<swb-footer-menu></swb-footer-menu>